import { IFormPBMManagers } from 'legacy/lut/classes/models/partner360/IFormPBMManagers'

export const FULL_EMAIL_REGEX =
  /(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/g

export const defaultItem: IFormPBMManagers = {
  EntryId: 0,
  ManagerEmail: '',
  ManagerFirstName: '',
  ManagerLastName: '',
  PBMConfirmed: 0,
  PBMEmail: '',
  ProgramType: '',
}

export const FIELDS_TO_SEARCH_MANAGER = ['UserAccountName']
